export const ConvertToTransactionViewDetailList = (transactionViewDetailRawList: any) => {
  const transactionViewDetailList = [];
  if (transactionViewDetailRawList && transactionViewDetailRawList.length > 0) {
    for (const transactionViewDetailRaw of transactionViewDetailRawList) {
      transactionViewDetailList.push({
        id: transactionViewDetailRaw.id,
        number: transactionViewDetailRaw.number,
        financeType: transactionViewDetailRaw.financeType,
        transactionItemType: transactionViewDetailRaw.transactionItemType,
        contactId: transactionViewDetailRaw.contactId,
      });
    }
  }
  return transactionViewDetailList;
};
